var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtClientOnly',[_c('button',{staticClass:"btn btn-outline-white btn-lg no-invert",on:{"click":_vm.becomeContributorLink}},[_vm._v("\n    "+_vm._s(_vm.$t('cta.be_our_contributor'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }